var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v(_vm._s(_vm.section.name))]),_c('p',[_vm._v(_vm._s(_vm.section.description))]),_c('ul',_vm._l((_vm.section.items),function(item){return _c('SPItem',{key:item.id,attrs:{"item":item}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }